import{styled as a}from"styled-components";const e=a.div.attrs({className:"form-field"})`
  font-family: 'Lucida Grande', 'Lucida Sans Unicode', Helvetica, Arial, Verdana, sans-serif;
  clear: both;
  margin: 0px 3px 2px;
  min-height: 22px;
  word-break: break-all;
  overflow-y: auto;
`;export{e as FormField};
